var _circle, _circle2, _circle3, _circle4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavBarLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A8CDFF",
    fillOpacity: 0.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7101,
    cy: 11.8424,
    r: 4.66368,
    fill: "#4147D5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A8CDFF",
    fillOpacity: 0.34
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7101,
    cy: 11.8424,
    r: 4.66368,
    fill: "#4147D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_5790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3718 22.3984H10.5146C10.2721 22.3984 10.0396 22.302 9.86813 22.1306C9.69667 21.9592 9.60034 21.7266 9.60034 21.4841V11.427C9.60034 11.1845 9.69667 10.9519 9.86813 10.7805C10.0396 10.609 10.2721 10.5127 10.5146 10.5127H20.5718C20.8142 10.5127 21.0468 10.609 21.2183 10.7805C21.3897 10.9519 21.4861 11.1845 21.4861 11.427V18.2841L17.3718 22.3984Z",
    fill: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3689 18.7403V22.3975L21.4832 18.2832H17.826C17.7048 18.2832 17.5885 18.3314 17.5028 18.4171C17.4171 18.5028 17.3689 18.6191 17.3689 18.7403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3689 18.7403V22.3975L21.4832 18.2832H17.826C17.7048 18.2832 17.5885 18.3314 17.5028 18.4171C17.4171 18.5028 17.3689 18.6191 17.3689 18.7403Z",
    stroke: "#4147D5",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3718 22.3984H10.5146C10.2721 22.3984 10.0396 22.302 9.86813 22.1306C9.69667 21.9592 9.60034 21.7266 9.60034 21.4841V11.427C9.60034 11.1845 9.69667 10.9519 9.86813 10.7805C10.0396 10.609 10.2721 10.5127 10.5146 10.5127H20.5718C20.8142 10.5127 21.0468 10.609 21.2183 10.7805C21.3897 10.9519 21.4861 11.1845 21.4861 11.427V18.2841L17.3718 22.3984Z",
    stroke: "#4147D5",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_5790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(9.13892 10.0557)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarLinkIcon);
export default __webpack_public_path__ + "static/media/navBarLinkIcon.f471a740bd2f89202e970d392799b263.svg";
export { ForwardRef as ReactComponent };